import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "security"
    }}>{`Security`}</h1>
    <p>{`Users must be able to access an add-on without compromising their security or negatively affecting their systems.`}</p>
    <p>{`Use these guidelines to ensure the security of your add-on.`}</p>
    <h2 {...{
      "id": "malicious-code"
    }}>{`Malicious code`}</h2>
    <p>{`Your add-on must not include any malicious code, viruses or malware that could harm a user’s system, or compromise their data.`}</p>
    <h2 {...{
      "id": "user-information"
    }}>{`User information`}</h2>
    <p>{`Your add-on must not transmit any sensitive user information without prior authorization or consent.`}</p>
    <h2 {...{
      "id": "vulnerabilities"
    }}>{`Vulnerabilities`}</h2>
    <p>{`Your add-on must not feature any currently-known security vulnerabilities, such as unsecured communication channels, weak authentication mechanisms, or potential injection attacks.`}</p>
    <p>{`We expect developers to maintain their add-on after completion and listing. This includes fixing bugs and addressing any security issues. It is also good practice to be responsive to user feedback and requests.`}</p>
    <h2 {...{
      "id": "secure-coding"
    }}>{`Secure coding`}</h2>
    <p>{`Your add-on must follow secure coding practices, such as input validation, as well as proper error handling.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      